// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class FormHeader extends Component {
  render() {
    const { customClasses, title, subtitle, progressBar = false, step } = this.props;

    return (
      <header className={classNames('form__header', customClasses)}>
        {title && <h2 className="form__header-title">{title}</h2>}
        {progressBar && (
          <div className="form__progress-bar">
            <div
              className="form__progress-bar-fill"
              style={{ width: `${step === 1 ? '50%' : '100%'}` }}
            ></div>
          </div>
        )}
        {subtitle && <p className="form__header-subtitle">{subtitle}</p>}
      </header>
    );
  }
}

FormHeader.propTypes = {
  customClasses: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  progressBar: PropTypes.bool,
  step: PropTypes.number,
};
